// Angular
import {Injectable} from '@angular/core';
// Model
import {BroadcastEventModel} from '../model/broadcast-event.model';
// Other
import { Observable, Subject } from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class BroadcastService {
	private subject: Subject<any> = new Subject();

	/**
	 * Broadcasts an event.
	 * @param event: any
	 */
	broadcast(event: BroadcastEventModel): void {
		this.subject.next(event);
	}

	/**
	 * On Event broadcast, subscribe the callback.
	 * @param eventName: string
	 * @param callback: any
	 */
	on(eventName: string, callback: any): any {
		const subscription: any = this.subject.pipe(
			filter((value: any) => value.name === eventName)
		).subscribe(callback);
		return (): void => {
			subscription.remove(subscription);
			subscription.unsubscribe();
		};
	}

	/**
	 * On Event broadcast, send the subscription.
	 * Use this for safe subscriptions that needs to destroy on component destruction. (avoid hanged subscriptions)
	 * @param eventName: string
	 * @param callback: any
	 */
	onEvent(eventName: string): Observable<any> {
		const subscription: any = this.subject.pipe(
			filter((value: any) => value.name === eventName)
		);
		return subscription;
	}
}
